import React from 'react'
import { useParams } from 'react-router'
import LbGsAddDomain from '../../Components/LeadBridge/LbGsAddDomain'
import LbGsCreateForm from '../../Components/LeadBridge/LbGsCreateForm'
import LbGsGoToDashboard from '../../Components/LeadBridge/LbGsGoToDashboard'
import LbGsHero from '../../Components/LeadBridge/LbGsHero'
import styles from './LbGetStarted.module.css'

const LbGetStarted = () => {
    const { step } = useParams()
    return (
        <div>
            {/* <LbGsHero /> */}
            {/* {step==="domain" && <LbGsHero />} */}
            {step==="add-domain" && <LbGsAddDomain />}
            {step==="create-form" && <LbGsCreateForm />}
            {/* {step==="go-to-dashboard" && <LbGsGoToDashboard />} */}
            {/* <LbGsAddDomain /> */}
{/* 
            LbGetStartedHero	Hero section with intro CTA
LbAddDomain	Domain registration step
LbCreateForm	Form + token generation section
LbEmbedScript	Script copy section
LbVerifyIntegration	Real-time integration test
LbResources	Post-setup help
LbGoToDashboard */}
        </div>
    )
}

export default LbGetStarted